// removed by extract-text-webpack-plugin
module.exports = {"rippleWrapper":"rippleWrapper__2GBlU","ripple":"ripple__6cBaH","rippleRestarting":"rippleRestarting__1oAjW","rippleActive":"rippleActive__1oBqc"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/ripple/theme.css
// module id = C9PJ
// module chunks = 6